export const BIG_TABLET_SIZE = 1023;
export const TABLET_SIZE = 768;
export const SMALL_TABLET_SIZE = 630;
export const LOADER_COLOR = "rgb(118, 191, 114)";
export const PRIMARY_COLOR = "rgb(118, 191, 114)";
export const GREY_COLOR = "rgb(146, 146, 146)";
export const CODE_TAB_ACCOUNT = "account";
export const CODE_TAB_ORDERS = "orders";
export const CODE_TAB_LOYALTY = "credits";
export const CODE_TAB_ORDERS_COMING = "coming";
export const CODE_TAB_ORDERS_PAST = "past";
export const CODE_TAB_INFOS = "informations";
export const CODE_TAB_SUBSCRIPTION = "subscription";
export const CODE_TAB_PASSWORD = "password";
export const CODE_TAB_CREDITS = "points";
export const CODE_TAB_BALANCE = "balance";
export const ID_MODAL = "modal-contenaire";
export const FRONT_SESSION_CODE = "forcingFront";
export const PAYBOX_SESSION_CODE = "forcingPaybox";
export const START_DATE_SESSION_CODE = "startDate";
export const TRUSTPILOT_BG_COLOR = "#363636";
export const WHITE_COLOR = "#fff";
export const SECTION_PRICE_PAYBOX_ID = "priceBox";
